import { isBandScale } from '../../../../core/utils/detect-scale.js';
import { AnyXYChartScale } from '../../../types/xy-chart-internals.js';

const getInvertedValue = (selectPosition: number, scale?: AnyXYChartScale) => {
  if (!scale || isBandScale(scale)) {
    return undefined;
  }
  const inverted = scale.invert?.(selectPosition);
  return inverted !== undefined ? new Date(inverted) : undefined;
};

export const getTimeframe = (
  start: number,
  end: number,
  isAxisNotReversed: boolean,
  scale?: AnyXYChartScale,
) => {
  return {
    start: getInvertedValue(isAxisNotReversed ? start : end, scale),
    end: getInvertedValue(isAxisNotReversed ? end : start, scale),
  };
};
